import { useRiskMapStore } from './RiskMapStore';
import { RiskMapRequest } from '../services/RiskMapRequest';

/**
 * Factory function that creates and returns the real RiskMapStore instance.
 * Supports dependency injection for testing by accepting a request instance.
 * @param requestInstance - RiskMapRequest instance for dependency injection
 */
export const createRiskMapStore = (requestInstance: RiskMapRequest) => {
    return useRiskMapStore(requestInstance)();
};

// Export the factory as the default export for easy importing
export default createRiskMapStore;
